import React from 'react';
import { UserHeader } from 'shared/ui/user-header/user-header';
import { BusinessApi } from 'shared/api';
import { WorkSchedule } from 'features/index';

interface IEmployeeHeaderProps {
  employeeId: string;
  dataFio: string;
  dataEmail: string;
  dataPhone: string;
  dataImgUrl: string;
}
export const EmployeeHeader: React.FC<IEmployeeHeaderProps> = ({
  employeeId,
  dataFio,
  dataPhone,
  dataEmail,
  dataImgUrl,
}) => {
  const handleDelete = async () => {
    if (employeeId) {
      await BusinessApi.deleteEmployee({ employeeId });
    }
  };

  return (
    <UserHeader
      fio={dataFio}
      phone={dataPhone}
      email={dataEmail}
      imgUrl={dataImgUrl}
      onSaveImage={(url: string) =>
        BusinessApi.updateEmployeeInfo({ employeeId, imgUrl: url })
      }
      deleteButton={{
        text: 'Удалить сотрудника',
        onClick: handleDelete,
      }}
      successMessage="Сотрудник успешно удален"
      extraContent={<WorkSchedule />}
    />
  );
};
